//通用-时长单位
export const timeUnit = [
  {id: 0, msg: "无"},
  {id: 1, msg: "分钟"},
  {id: 2, msg: "小时"},
  {id: 3, msg: "天"},
  {id: 4, msg: "周"},
  {id: 5, msg: "月"},
  {id: 6, msg: "年"},
];

//用户管理
export const userOnline = [
  {id: 0, msg: "离线", color: "color-danger"},
  {id: 1, msg: "在线", color: "color-success"},
];
export const bindType = [
  {id: 0, msg: "不绑定"},
  {id: 1, msg: "自动绑定"},
  {id: 2, msg: "手动绑定"},
];
export const accountType = [
  {id: "0", msg: "个人账号"},
];
export const accountSource = [
  {id: "counter", msg: "柜台创建"},
  {id: "mini", msg: "小程序注册"},
  {id: "mp", msg: "公众号注册"},
  {id: "portal", msg: "Portal注册"},
  {id: "register", msg: "用户注册"},
  {id: "migrate", msg: "迁移"},
];
export const accountStatus = [
  {id: 0, msg: "正常", color: "color-success"},
  {id: 1, msg: "禁用", color: "color-danger"},
  {id: 2, msg: "冻结", color: "color-primary"},
  {id: 3, msg: "到期", color: "color-warning"},
  {id: 4, msg: "停机保号", color: "color-disable"},
  {id: 7, msg: "未激活", color: "color-warning"},
];
export const authType = [
  {id: 0, msg: "禁用"},
  {id: 1, msg: "WEB"},
  {id: 2, msg: "PPPOE"},
  {id: 3, msg: "WEB+PPPOE"},
];

//设备管理
export const deviceOnline = [
  {id: 0, msg: "离线", color: "color-danger"},
  {id: 1, msg: "在线", color: "color-success"},
];
export const deviceType = [
  {id: 0, msg: "未知"},
  {id: 1, msg: "路由器"},
  {id: 2, msg: "防火墙"},
  {id: 3, msg: "AP"},
  {id: 4, msg: "交换机"},
  {id: 5, msg: "IPTV"},
  {id: 7, msg: "软路由"},
];
export const deviceFunction = [
  {id: -1, msg: "不支持", color: "color-danger"},
  {id: 0, msg: "未开启", color: "color-warning"},
];

//商家管理
export const shopStatus = [
  {id: 0, msg: "已禁用", color: "color-danger"},
  {id: 1, msg: "已启用", color: "color-success"},
];
export const adminType = [
  {id: 0, msg: "子账号", color: "color-danger"},
  {id: 1, msg: "管理员", color: "color-success"},
];
export const settlementMode = [
  {id: 1, msg: "转账收款"},
  {id: 2, msg: "自主收款"},
];

//插件管理
export const pluginStatus = [
  {id: 1, msg: "已启用", color: "color-success"},
  {id: 0, msg: "已禁用", color: "color-danger"},
];
export const pluginType = [
  {id: "bill", msg: "计费"},
  {id: "audit", msg: "审计"},
];
export const platformType = [
  "MT7620",
  "MT7621",
  "MT7628",
  "MT7623",
  "MT3052",
  "ralink",
  "qca",
  "athores",
  "x86-64",
  "x86",
  "cavium",
  "cortina",
  "realtek",
  "marvell",
];
export const coreType = [
  {id: "4.4.198", msg: "4.4.198"},
];

//财务管理
export const billMethod = [
  {id: "wxpay", msg: "微信"},
  {id: "alipay", msg: "支付宝"},
  {id: "card", msg: "充值卡"},
  {id: "cash", msg: "现金"},
  {id: "system", msg: "系统"},
];
export const billStatus = [
  {id: 0, msg: "未支付", color: "color-warning"},
  {id: 1, msg: "已支付", color: "color-success"},
  {id: 2, msg: "已取消", color: "color-danger"},
  {id: 3, msg: "订单过期", color: "color-disable"},
  {id: 4, msg: "订单已退款", color: "color-primary"},
  // {id: 5, msg: "订单已锁定", color: "color-disable"},
];
export const transferStatus = [
  {id: 0, msg: "未转账", color: "color-warning"},
  {id: 1, msg: "已转账", color: "color-success"},
  {id: 2, msg: "失败", color: "color-danger"},
];
export const billShopAction = [
  {id: "sms", msg: "购买短信"},
  {id: "user", msg: "购买授权"},
  {id: "user_renew", msg: "续费授权"},
];
export const billUserAction = [
  {id: "new", msg: "新购买套餐"},
  {id: "renew", msg: "续费套餐"},
  {id: "change", msg: "更换套餐"},
  {id: "refund", msg: "停机退费", color: "color-danger"},
  // {id: "extra", msg: "叠加套餐"},
];

//系统设置
export const auditModule= [
  {id: "account", msg: "认证账号"},
  {id: "virtual", msg: "虚拟身份"},
  {id: "url", msg: "上网网址"},
  {id: "bbs", msg: "网络论坛"},
  {id: "email", msg: "电子邮件"},
  {id: "terminal", msg: "终端采集"},
];

//短信管理
export const smsSendStatus= [
  {id: 0, msg: "成功", color: "color-success"},
  {id: 1, msg: "失败", color: "color-warning"},
  {id: 2, msg: "正在发送", color: "color-warning"},
];
export const smsSendType = [
  {id: "login", msg: "商户-平台登录"},
  {id: "register", msg: "商户-平台注册"},
  {id: "forget", msg: "商户-平台忘记密码"},
  {id: "modify", msg: "商户-修改手机号"},
  {id: "wechat", msg: "商户-微信绑定"},
  {id: "payee", msg: "商户-修改收款配置"},
  {id: "admin", msg: "管理员-登陆"},
  {id: "user_mini_register", msg: "用户-小程序注册"},
  {id: "user_mini_forget", msg: "用户-小程序忘记密码"},
  {id: "user_portal_register", msg: "用户-Portal注册"},
  {id: "user_portal_forget", msg: "用户-Portal忘记密码"},
  {id: "user_login", msg: "用户登录"},
  {id: "user_register", msg: "用户注册"},
  {id: "user_forget", msg: "用户忘记密码"},
  {id: "user_register_notify", msg: "用户注册通知"},
  {id: "common", msg: "通用模板"},
];
export const smsTemplateType = [
  {id: "user_login", msg: "用户登录"},
  {id: "user_register", msg: "用户注册"},
  {id: "user_forget", msg: "用户忘记密码"},
  {id: "user_register_notify", msg: "用户注册通知"},
  {id: "common", msg: "通用模板"},
];

export const smsTemplateStatus = [
  {id: 0, msg: "已禁用", color: "color-danger"},
  {id: 1, msg: "已启用", color: "color-success"},
];

//权限管理
export const adminAccountStatus = [
  {id: 0, msg: "已禁用", color: "color-danger"},
  {id: 1, msg: "已启用", color: "color-success"},
];
